/* GENT concept ("The Routine"), 2026-10-26. Behaviour for the gx-* sections.
   - [data-gx-add="<variant id>"] adds to cart and opens Dawn's own cart drawer (same call product-form.js makes).
   - [data-gx-starter]  two-question starting-point picker.
   - [data-gx-filter]   collection chips: reorder so the concern's lead product comes first.
   - [data-gx-pop]      welcome slide-in, subscribes to a Klaviyo list via the client API, then reveals the code. */
(function () {
  'use strict';

  function cartDrawer() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-gx-swap]');
    if (sw) {
      e.preventDefault(); sw.setAttribute('aria-busy', 'true');
      var updates = {}; sw.dataset.remove.split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { addVariant(sw.dataset.gxSwap, 1, sw); });
      return;
    }
    var btn = e.target.closest('[data-gx-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn.dataset.gxAdd, btn.dataset.qty || 1, btn);
  });

  function addVariant(id, qty, btn) {
    var cart = cartDrawer();
    var body = { id: Number(id), quantity: Number(qty) };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.setAttribute('aria-busy', 'true');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.removeAttribute('aria-busy');
      if (res.status) { alert(res.description || res.message); return; }
      if (cart && cart.renderContents) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
        document.dispatchEvent(new CustomEvent('gx:cart-updated'));
      } else { window.location = window.routes ? window.routes.cart_url : '/cart'; }
    }).catch(function () { btn.removeAttribute('aria-busy'); window.location = '/cart'; });
  }

  /* ---------- starting-point picker ---------- */
  function initStarter(root) {
    var data = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var state = { q1: data.defaultQ1, q2: data.defaultQ2 };
    var out = root.querySelector('[data-gx-result]');
    function draw() {
      root.querySelectorAll('[data-q1]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.q1 === state.q1)); });
      root.querySelectorAll('[data-q2]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.q2 === state.q2)); });
      root.querySelectorAll('[data-who]').forEach(function (el) { el.textContent = state.q1 === 'him' ? 'him' : 'you'; });
      var c = data.concerns.filter(function (x) { return x.k === state.q2; })[0];
      if (!c) return;
      var head = state.q1 === 'him' ? data.headHim : state.q1 === 'have' ? data.headHave.replace('[step]', c.short.toLowerCase()) : data.headNew;
      out.querySelector('[data-r-head]').textContent = head;
      out.querySelector('[data-r-num]').textContent = c.step;
      out.querySelector('[data-r-line]').textContent = c.line;
      var single = out.querySelector('[data-r-single]');
      if (state.q1 === 'have' && c.variant) {
        single.hidden = false; single.dataset.gxAdd = c.variant; single.textContent = 'Just the ' + c.short.toLowerCase() + ' · ' + c.price;
      } else { single.hidden = true; }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q1],[data-q2]'); if (!b) return;
      if (b.dataset.q1) state.q1 = b.dataset.q1; else state.q2 = b.dataset.q2; draw();
    });
    draw();
  }

  /* ---------- collection chips ---------- */
  function initFilter(root) {
    var grid = root.querySelector('[data-gx-grid]');
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gx-chip]'); if (!b) return;
      root.querySelectorAll('[data-gx-chip]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var lead = b.dataset.lead;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-gx-card]'));
      cards.forEach(function (c) { c.classList.toggle('is-lead', !!lead && c.dataset.handle === lead); });
      var slots = Array.prototype.slice.call(grid.querySelectorAll('[data-gx-slot]'));
      var ordered = lead ? cards.filter(function (c) { return c.dataset.handle === lead; }).concat(cards.filter(function (c) { return c.dataset.handle !== lead; })) : cards.sort(function (a, b) { return a.dataset.pos - b.dataset.pos; });
      ordered.forEach(function (c, i) { if (slots[i]) slots[i].appendChild(c); });
      var t = root.querySelector('[data-gx-title]'), l = root.querySelector('[data-gx-lede]');
      if (t) t.textContent = b.dataset.title; if (l) l.textContent = b.dataset.lede;
    });
  }

  /* ---------- welcome slide-in ---------- */
  function initPop(root) {
    var pop = root.querySelector('.gx-pop'), tab = root.querySelector('.gx-poptab');
    var KEY = 'gx-welcome';
    var seen = false; try { seen = !!localStorage.getItem(KEY); } catch (e) {}
    function open() { pop.classList.add('is-on'); tab.classList.remove('is-on'); }
    function close() { pop.classList.remove('is-on'); tab.classList.add('is-on'); try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    if (seen) tab.classList.add('is-on');
    else if (!window.Shopify || !Shopify.designMode) setTimeout(function () { if (!document.querySelector('cart-drawer.active')) open(); }, Number(root.dataset.delay || 7) * 1000);
    tab.addEventListener('click', open);
    root.querySelector('.gx-pop__x').addEventListener('click', close);
    var form = root.querySelector('form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { form.querySelector('input').focus(); return; }
      var btn = form.querySelector('button'); btn.setAttribute('aria-busy', 'true');
      var done = function () { root.querySelector('[data-gx-form]').hidden = true; root.querySelector('[data-gx-done]').hidden = false; try { localStorage.setItem(KEY, '1'); } catch (er) {} };
      if (!root.dataset.company || !root.dataset.list) { done(); return; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'GENT theme welcome slide-in', profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: root.dataset.list } } } } })
      }).then(done, done);
    });
    var copy = root.querySelector('[data-gx-copy]');
    if (copy) copy.addEventListener('click', function () {
      try { navigator.clipboard.writeText(copy.dataset.gxCopy).catch(function () {}); } catch (e) {}
      copy.textContent = 'Copied';
    });
  }

  /* ---------- estimated delivery (mock-up format) ----------
     Same rules as the estimated_delivery block: processing days, cut-off, N delivery days, holidays, shop timezone.
     Defaults match the block's schema defaults (Mon-Fri, 15:00, 2 days) for pages without the block (cart drawer). */
  var ETA_DEFAULT = { processingDays: [1, 2, 3, 4, 5], deliveryDays: [1, 2, 3, 4, 5], cutoffHour: 15, cutoffMinute: 0, numDeliveryDays: 2, timezone: 'Europe/London', processingHolidays: [], deliveryHolidays: [] };
  function etaSettings() {
    var el = document.querySelector('[data-delivery-settings]');
    try { return el ? Object.assign({}, ETA_DEFAULT, JSON.parse(el.textContent)) : ETA_DEFAULT; } catch (e) { return ETA_DEFAULT; }
  }
  function nowIn(tz) {
    try {
      var parts = {}; new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = +p.value; });
      return new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
    } catch (e) { return new Date(); }
  }
  function key(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function eta(s) {
    var now = nowIn(s.timezone), d = new Date(now), ph = (s.processingHolidays || []).map(function (x) { return String(x).trim(); }), dh = (s.deliveryHolidays || []).map(function (x) { return String(x).trim(); });
    var proc = function (x) { return s.processingDays.indexOf(x.getDay()) > -1 && ph.indexOf(key(x)) < 0; };
    var deli = function (x) { return s.deliveryDays.indexOf(x.getDay()) > -1 && dh.indexOf(key(x)) < 0; };
    var cutMins = s.cutoffHour * 60 + (s.cutoffMinute || 0), nowMins = now.getHours() * 60 + now.getMinutes();
    var today = proc(d) && nowMins < cutMins;
    if (!today) { do { d.setDate(d.getDate() + 1); } while (!proc(d)); }
    var n = 0; while (n < s.numDeliveryDays) { d.setDate(d.getDate() + 1); if (deli(d)) n++; }
    var left = today ? cutMins - nowMins : 0;
    return { date: d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }), left: today ? Math.floor(left / 60) + 'h ' + (left % 60) + 'm' : null };
  }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function paintEta() {
    var s = etaSettings(), r = eta(s);
    document.querySelectorAll('[data-gx-eta]').forEach(function (box) {
      var html = r.left ? 'Order within <b>' + r.left + '</b> for estimated delivery <b>' + r.date + '</b>' : 'Estimated delivery <b>' + r.date + '</b>';
      var tx = box.querySelector('[data-gx-eta-text]'); if (tx.innerHTML !== html) tx.innerHTML = html;
      var after = Number(box.dataset.cart) + Number(box.dataset.price), th = Number(box.dataset.threshold) || 4000, gap = Math.max(0, th - after);
      box.querySelector('[data-gx-eta-bar]').style.width = Math.min(100, after / th * 100) + '%';
      box.querySelector('[data-gx-eta-meter]').textContent = gap ? 'Add ' + money(gap) + ' more for free UK delivery' : 'This order qualifies for free UK delivery';
    });
    document.querySelectorAll('[data-gx-eta-date]').forEach(function (el) { if (el.textContent !== r.date) el.textContent = r.date; }); // guarded: the drawer observer would otherwise loop
  }
  function refreshCartTotal() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-gx-eta]').forEach(function (b) { b.dataset.cart = c.total_price; }); paintEta();
    }).catch(function () {});
  }
  document.addEventListener('gx:cart-updated', refreshCartTotal);
  if (window.subscribe && window.PUB_SUB_EVENTS) { try { subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartTotal); } catch (e) {} }
  setInterval(paintEta, 60000);
  // The drawer re-renders its own HTML; fill its delivery line whenever that happens.
  function watchDrawer() { var d = document.querySelector('cart-drawer'); if (d) new MutationObserver(paintEta).observe(d, { childList: true, subtree: true }); }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gx-starter]').forEach(initStarter);
    (scope || document).querySelectorAll('[data-gx-filter]').forEach(initFilter);
    (scope || document).querySelectorAll('[data-gx-pop]').forEach(initPop);
  }
  /* ---------- product page (2026-10-30) ---------- */
  // Quantity beside the button: keep "Add to basket · £x" in step with the quantity.
  document.addEventListener('change', function (e) {
    var row = e.target.closest && e.target.closest('.gx-buyrow'); if (!row) return;
    var lab = row.querySelector('[data-gx-atc]'); if (!lab) return;
    var q = Math.max(1, parseInt(row.querySelector('.quantity__input').value, 10) || 1);
    lab.textContent = 'Add to basket · ' + money(Number(lab.dataset.price) * q);
  });
  // For me / For him: drives the same html[data-gent-for] + sessionStorage the ?for= links use.
  function paintAud() {
    var v = document.documentElement.getAttribute('data-gent-for') || 'm';
    document.querySelectorAll('[data-gx-aud] [data-aud]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.aud === v)); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gx-aud] [data-aud]'); if (!b) return;
    document.documentElement.setAttribute('data-gent-for', b.dataset.aud);
    try { sessionStorage.setItem('gent_for', b.dataset.aud); } catch (er) {}
    paintAud();
  });
  // Product page only: show the stone-plinth scene first. It is the LAST product image (so the featured image used by
  // collection cards, Meta and Google is unchanged); here it is moved to the front and activated through Dawn's own
  // thumbnail handler, which keeps the gallery's active state, live region and counter consistent.
  function plinthFirst() {
    var g = document.querySelector('media-gallery'); if (!g) return;
    var item = Array.prototype.slice.call(g.querySelectorAll('.product__media-item')).filter(function (li) {
      var im = li.querySelector('img'); return im && /gx-plinth/.test(im.currentSrc || im.src || '');
    })[0];
    if (!item) return;
    item.style.order = '-1';
    var id = item.dataset.mediaId;
    var thumbBtn = id && g.querySelector('.thumbnail-list__item[data-target="' + id + '"] button');
    if (!thumbBtn) return;
    thumbBtn.closest('.thumbnail-list__item').style.order = '-1';
    // Dawn binds the thumbnail listeners in media-gallery's constructor; click only once that has run.
    (window.customElements ? customElements.whenDefined('media-gallery') : Promise.resolve()).then(function () {
      setTimeout(function () { thumbBtn.click(); }, 0);
    });
  }
  // Footer sign-up: same Klaviyo list and route as the welcome slide-in.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-gx-sub-form]'); if (!f) return;
    e.preventDefault();
    var box = f.closest('[data-gx-sub]'), email = f.querySelector('input[type="email"]').value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { f.querySelector('input').focus(); return; }
    var done = function () { f.hidden = true; box.querySelector('[data-gx-sub-done]').hidden = false; };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(box.dataset.company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'GENT theme footer', profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: box.dataset.list } } } } })
    }).then(done, done);
  });

  function boot() { init(); paintEta(); watchDrawer(); paintAud(); plinthFirst(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
